<template>
  <div class="content">
      回收站
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>